var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ReplaySubject, Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { input } from "./InputState";
import { State } from "./State";
var MultiInputState = /** @class */ (function (_super) {
    __extends(MultiInputState, _super);
    // private cache: Cache<T>;
    function MultiInputState() {
        var _this = this;
        // const cache: Cache<T> = {};
        var cache$ = new ReplaySubject(1);
        var afterConnect = function (state, setStateFn) {
            setStateFn({});
        };
        var afterDisConnect = function (state, setStateFn) {
            _this.clear();
            setStateFn({});
        };
        _this = _super.call(this, cache$.asObservable(), function (val) { return val === undefined; }, afterConnect, afterDisConnect) || this;
        _this.cache$ = cache$;
        _this.change$ = new Subject();
        _this.remove$ = new Subject();
        return _this;
    }
    MultiInputState.prototype.clear = function () {
        for (var id in this.value) {
            if (this.value.hasOwnProperty(id)) {
                var state = this.value[id];
                state.disconnect();
            }
        }
        this.cache$.next({});
        return this;
    };
    MultiInputState.prototype.get = function (id) {
        var _this = this;
        if (this.value[id] === undefined) {
            var newState_1 = input();
            if (this.name) {
                newState_1.name = this.name + "[" + id + "]";
            }
            this.value[id] = newState_1;
            newState_1.changes$().pipe(takeUntil(this.observeRemove().pipe(filter(function (val) { return val === id; }))))
                .subscribe(function (val) {
                _this.change$.next([id, val, newState_1]);
            });
            this.cache$.next(this.value);
        }
        return this.value[id];
    };
    MultiInputState.prototype.remove = function (id) {
        var state = this.value[id];
        if (state !== undefined) {
            state.disconnect();
            delete this.value[id];
            this.cache$.next(this.value);
            this.remove$.next(id);
        }
        return state;
    };
    MultiInputState.prototype.observeChange = function () {
        return this.change$.asObservable();
    };
    MultiInputState.prototype.observeRemove = function () {
        return this.remove$.asObservable();
    };
    return MultiInputState;
}(State));
export { MultiInputState };
export function multiInput() {
    return new MultiInputState();
}
